import { fetchAuthSession } from 'aws-amplify/auth';
import { EMISSIONS_API_URL } from './apiConfig';

export const DASHBOARD_REFRESH_KEY = 'datenerhebung_saved';

export async function fetchDashboardSnapshot() {
  const session = await fetchAuthSession();
  const response = await fetch(EMISSIONS_API_URL, {
    cache: 'no-store',
    headers: { Authorization: `Bearer ${session.tokens.idToken.toString()}` },
  });
  if (!response.ok) throw new Error('Dashboard-Daten konnten nicht geprüft werden. Bitte erneut versuchen.');
  return response.json();
}

export function serializeReportingYear(data, year) {
  let payload = data;
  if (typeof data?.body === 'string') payload = JSON.parse(data.body);
  else if (data?.body != null) payload = data.body;
  const rows = Array.isArray(payload) ? payload : payload?.reporting_data ?? payload?.rows;
  if (!Array.isArray(rows)) throw new Error('Unbekanntes Antwortformat der Dashboard-Daten.');
  return JSON.stringify(rows.filter(row => String(row?.year) === String(year)));
}
